export default __webpack_public_path__ + "static/media/Slider_Products-1.d71a7ef9.mp4";